/* ════════════════════════════════════════════════════════════
   AMSX-Analytix Official Logo (exact uploaded brand asset)
   Extracted from index.jsx — Tier 1 split
   ──────────────────────────────────────────────────────────── */

import React from "react";
import { AMSX_LOGO } from "../constants";

export default function AmsxLogo(props) {
  var h = props.height || 32;
  var w = Math.round(h * (433 / 120));
  return React.createElement("img", {
    src: AMSX_LOGO,
    alt: "AMSX-Analytix",
    style: {
      height: h,
      width: w,
      objectFit: "contain",
      flexShrink: 0,
      display: "block"
    }
  });
}
